import React, {memo} from 'react';

import Block from '../components/block';

import style from './404.module.scss';

export default memo(
	/**
	 * @param {import("gatsby").PageProps} props
	 * @returns {React.ReactNode} ...
	 */
	function NotFound({}) {
		return (
			<Block padding={true}>
				<h1 className={style.pageTitle}>
					404 - Seite nicht gefunden
				</h1>
			</Block>
		);
	}
);
